import { ServerVars } from 'server-vars';
import { ABConfig, experimentConfigProps } from './types/abTesting';

const CONTROL = 'CONTROL';
const VARIANT = 'VARIANT';
const INELIGIBLE = 'INELIGIBLE';

const TEST_TYPE_MOBILE = 'MOBILE';
export const TEST_TYPE_STANDARD = 'STANDARD';
const TEST_TYPE_RESPONSIVE = 'RESPONSIVE';

export const AB_TYPES: {
    CONTROL: typeof CONTROL;
    VARIANT: typeof VARIANT;
    INELIGIBLE: typeof INELIGIBLE;
} = { CONTROL, VARIANT, INELIGIBLE };

export type AB_TYPE = typeof CONTROL | typeof VARIANT | typeof INELIGIBLE;

/**
 * Return the A/B configuration
 */
export const getConfig = (serverVars: ServerVars): ABConfig => {
    const isMobile = serverVars.get('settings.isMobile');
    const abTestConfig = serverVars.get('abTestConfig') || {};
    const filteredConfigs = Object.keys(abTestConfig).reduce(
        (acc: ABConfig, configName: string) => {
            let activeConfig;
            const config = abTestConfig[configName];
            const standardConfig = config.find(
                (configItem: experimentConfigProps) => configItem.testType === TEST_TYPE_STANDARD
            );
            if (standardConfig) {
                activeConfig = standardConfig;
            } else {
                const testType = isMobile ? TEST_TYPE_MOBILE : TEST_TYPE_RESPONSIVE;
                activeConfig = config.find(
                    (configItem: experimentConfigProps) => configItem.testType === testType
                );
            }
            if (!acc[configName]) {
                acc = { ...acc, [configName]: activeConfig };
            }
            return acc;
        },
        {}
    );

    return filteredConfigs;
};

export const getPageType = (serverVars: ServerVars): string => {
    return serverVars.get('settings').pageType || '';
};
